import React, { useState, useEffect } from 'react';
import { StationPause as DisplayStationPause } from '../types/Team';
import { Station } from '../types/Station';
import { fetchStations } from '../api/apis';

interface PauseFormProps {
  pause?: DisplayStationPause;
  onSubmit: (data: {
    stationId: string;
    startEventTime: string;
    endEventTime: string;
  }) => void;
  onCancel: () => void;
  loading: boolean;
}

export const PauseForm: React.FC<PauseFormProps> = ({
  pause,
  onSubmit,
  onCancel,
  loading,
}) => {
  const [stations, setStations] = useState<Station[]>([]);
  const [selectedStation, setSelectedStation] = useState<string>('');
  const [startTime, setStartTime] = useState<string>('');
  const [endTime, setEndTime] = useState<string>('');

  useEffect(() => {
    const loadStations = async () => {
      try {
        const stationsData = await fetchStations();
        setStations(stationsData);
      } catch (error) {
        console.error('Failed to load stations:', error);
      }
    };

    loadStations();
  }, []);

  useEffect(() => {
    if (pause) {
      // Find the station ID by name
      const station = stations.find(s => s.name === pause.stationName);
      if (station) {
        setSelectedStation(station.id);
      }
      setStartTime(pause.pauseTime);
      setEndTime(pause.resumeTime);
    }
  }, [pause, stations]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      stationId: selectedStation,
      startEventTime: startTime,
      endEventTime: endTime,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="station" className="block text-sm font-medium text-gray-700">
          Station
        </label>
        <select
          id="station"
          value={selectedStation}
          onChange={(e) => setSelectedStation(e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          required
        >
          <option value="">Select a station</option>
          {stations.map((station) => (
            <option key={station.id} value={station.id}>
              {station.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="startTime" className="block text-sm font-medium text-gray-700">
          Start Time
        </label>
        <input
          type="datetime-local"
          id="startTime"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          step="1"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          required
        />
      </div>

      <div>
        <label htmlFor="endTime" className="block text-sm font-medium text-gray-700">
          End Time
        </label>
        <input
          type="datetime-local"
          id="endTime"
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
          step="1"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          required
        />
      </div>

      <div className="flex justify-end space-x-2 mt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-gray-600 hover:text-gray-800"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Save'}
        </button>
      </div>
    </form>
  );
}; 